<template>
  <div class="custom-radio-group">
    <el-radio-group v-model="selectedValue" @change="handleChange" text-color="#5086FC" fill="#D8E4FF">
      <template v-for="(item, index) in options">
        <el-radio-button v-if="item.show !== false" :label="item.label" class="custom-radio-item">
          {{ item.value }}
          <el-tooltip
            v-if="item.tooltip"
            :content="item.tooltip"
            placement="top"
          >
            <i class="el-icon-question" style="margin-left: 5px; cursor: pointer; color: #578bf9"></i>
          </el-tooltip>
          <img
            v-if="selectedValue === item.label"
            src="@/assets/images/true.png"
            alt="Selected"
            class="selected-icon"
          />
        </el-radio-button>
      </template>
    </el-radio-group>
  </div>
</template>

<script>
export default {
  props: {
    options: {
      type: Array,
      required: true
    },
    value: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      selectedValue: this.value
    };
  },
  watch: {
    value(newValue) {
      this.selectedValue = newValue;
    }
  },
  methods: {
    handleChange() {
      this.$nextTick(() => {
        this.$emit('input', this.selectedValue);
        this.$emit('change', this.selectedValue);
      });
    }
  }
};
</script>

<style scoped>
.custom-radio-group {
  display: flex;
  flex-wrap: nowrap;
  white-space: nowrap;
  overflow-x: auto;
}

.custom-radio-item {
  position: relative;
  cursor: pointer;
  white-space: nowrap;
}

.custom-radio-item img.selected-icon {
  width: 20px;
  height: 20px;
  position: absolute; /* 使用绝对定位 */
  bottom: 0; /* 调整底部位置 */
  right: 0; /* 调整右侧位置 */
}
</style>
